import { memo, useRef, useState } from 'react';
import breakPoints from 'helpers/Styles';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Video from 'components/video';
import Link from 'next/link';

const YoutubeVideo = ({ block }) => {
  const {
    title1,
    description,
    buton_link,
    button_text,
    video_url,
    video_title,
    video_link,
  } = block.primary;

  const title = title1 ? title1 : null;
  const videoTitle = video_title ? video_title : null;
  const descriptions = description ? description : null;
  const videoDescription =
    block.primary && block.primary.video_description
      ? block.primary.video_description
      : null;

  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef();
  const onPlayButton = () => {
    setIsVideoPlaying(true);
    videoRef.current.play();
  };

  return (
    <>
      <div className="series_video_slice">
        <div className="video_block">
          {video_link?.url && (
            <div className="video_container">
              <video
                ref={videoRef}
                loop={true}
                muted={!isVideoPlaying}
                autoPlay={false}
                playsInline={true}
                controls={isVideoPlaying}
                className="video"
                onPause={() => setIsVideoPlaying(false)}
                onError="alert('Could\'nt load video')"
              >
                <source src={video_link?.url} type="video/mp4" />
              </video>
              {!isVideoPlaying && (
                <button className="play_button" onClick={onPlayButton}>
                  <img draggable="false" 
                    src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-play-red.png?v=1714039604"
                    alt="play-icon"
                    height={60}
                    width={60}
                  />
                </button>
              )}
            </div>
          )}
          {/* <VideoWithoutPlay
            videoUrl={video_url}
            videoHeight="600px"
            videoSource={video_link?.url}
            videoTitle={videoTitle}
            videoDescription={videoDescription}
          /> */}
        </div>

        <div className="find_your_setup">
          <div className="title">
            <h1>{title}</h1>
            <p>{descriptions}</p>
          </div>

          {button_text ? (
            <Link href={buton_link}>
              <a href={buton_link}>
                <div className="button_container">
                  <button type="button" className="two_column_button">
                    {button_text}
                  </button>
                  <div className="arrow_right">
                    <img draggable="false"  src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon_arrow_5.png?v=1714047897" alt="icon_arrow" />
                  </div>
                </div>
              </a>
            </Link>
          ) : null}
        </div>

        <style jsx>
          {`
            .youtube_video{
              border:none;
              flex-grow:1;
              aspect-ratio: 16/9;
              width:100%;
              max-width: 1440px;
              margin:0 auto;
              margin-top: 48px;
            }
            .video{
              width:100%;
              flex-grow:1;
              aspect-ratio: 16:9;
            }
            .play_button{
              position:absolute;
              background:none;
              border:none;
            }
            .video_container {
              position:relative;
              margin: 0 auto;
              max-width: 1440px;
              margin-top: 48px;
              display: flex;
              flex-direction:column;
              justify-content: center;
              align-items:center;
            }
            .series_video_slice {
              padding: 70px 0;
            }
            .video_block {
              width: 65%;
              height: 500px;
              margin: 0 auto;
            }
            .button_container {
              display: flex;
              width: 50%;
              margin: 0 auto;
              justify-content: center;
              margin-top:16px;
            }
            .find_your_setup{
              displayL flex;
              justify-content: center;
            }
            .title{
              width: 80%;
              margin: 0 auto;
            }
             .two_column_button {
              height: 48px;
              min-width: 128px;
              color: white;
              background: #891d1a;
              font-family: 'Roboto-Medium';
              font-size: 16px;
              font-weight: bold;
              letter-spacing: 0;
              line-height: 24px;
              border-radius: 3px 0 0 3px;
              border: none;
              outline: 0;
              padding: 12px 24px;
              text-transform: uppercase;
            
            }
            .arrow_right {
              width: 48px;
              height: 48px;
              background: #242424;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
            }
            .arrow_right img {
              width: 25px;
            }
            .title h1 {
              color: #e4e4e4;
              font-family: 'big_noodle_titling';
              font-size: 31px;
              letter-spacing: 0;
              line-height: 40px;
              text-align: center;
              margin:0;
            }
            .title p {
              color: #e4e4e4;
              font-family: 'Roboto-Medium';
              font-size: 16px;
              letter-spacing: 0;
              line-height: 24px;
              text-align: center;
              margin-top: 16px;
              margin-bottom: 24px;
            }
            @media (max-width: ${breakPoints.medium}) {
              .video_block {
                width: 90%;
                height: 400px;
                margin-top: 30px;
            
              }
              .find_your_setup{
                padding-top: 30px;
                padding-bottom: 30px;
              }
            @media (max-width: ${breakPoints.small}) {
              .button_container{
                width: 100%;
              }
              .video {
                height: 400px;
              }
              .series_video_slice {
                padding: 0px 0;
              }
              .video_block {
                width: 90%;
                height: 200px;
              }
              .find_your_setup{
                padding-top: 30px;
                padding-bottom: 30px;
              }
            }
              
          `}
        </style>
      </div>
    </>
  );
};

export default memo(YoutubeVideo);
